import { VehicleTypeType } from '@/common/queries/selections/vehicleType/vehicleType.type';
import { fetchApi } from '@/config/axiosSetting';

export const getVehicleTypeFunction = (): Promise<VehicleTypeType[]> => {
  return fetchApi.get('/selection_item/vehicle_type/wop_list/');
};
